<template>
    <div class="form-group col-md-6">
        <label for="city" class="mb-0"> {{ $t('city') }} </label>
        <app-input 
            id="city" 
            class="form-control" 
            :placeholder="$t('select_city')"                
            type="advance-search-select"
            :fetch-url='`/states/${state_id}/cities`'
            v-model="selected" 
            listValueField="name" 
            :loaded-per-time="5"  
        />
    </div>
</template>

<script>
    export default {
        name: 'cityAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            state_id :{
                type: [String, Number, Object],
                default: null
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
